export default __webpack_public_path__ + "static/media/responsive-design.e9a6279e.png";